import styled from '@emotion/styled';
import { TextField } from 'components/common';

export const MoreVideos = styled.div`
  padding: 2rem 1rem 0 0;
  display: flex;
  place-items: center;
`;

export const MoreVideosTitle = styled(TextField)`
  margin: 0;
`;
